import styled from "@emotion/styled"

const NeuroFitnessGamesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: var(--cms-surface-primary);
  color: var(--cms-text-primary);

  .heading-copy { display: flex; flex-direction: column; gap: 6px; }
  .page-title { margin: 0; color: var(--cms-text-primary); font-size: 30px; font-weight: 800; }
  .page-subtitle { margin: 0; max-width: 820px; color: var(--cms-text-secondary); font-size: 13px; line-height: 1.5; }
  .save-btn { min-height: 40px; border-radius: 10px; text-transform: none; font-weight: 700; }
  .page-surface {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 18px;
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: var(--cms-shadow);
  }
  .games-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(360px, 1fr)); gap: 16px; }
  .game-card {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 18px;
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-card-bg);
    box-shadow: var(--cms-shadow);
  }
  .game-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; }
  .game-header h2 { margin: 0 0 5px; color: var(--cms-text-primary); font-size: 19px; }
  .game-key { color: var(--cms-text-secondary); font-size: 11px; font-weight: 700; letter-spacing: 0.03em; }
  .thumbnail-row { display: grid; grid-template-columns: 180px minmax(0, 1fr); gap: 14px; align-items: center; }
  .thumbnail-actions { display: flex; flex-direction: column; align-items: flex-start; gap: 8px; }
  .thumbnail-actions button { text-transform: none; }
  .fields { display: grid; gap: 12px; }
  .admin-guide {
    border: 1px solid var(--cms-border);
    border-radius: 14px !important;
    overflow: hidden;
    background: var(--cms-surface-muted);
  }
  .admin-guide::before { display: none; }
  .admin-guide .MuiAccordionSummary-root { min-height: 64px; padding: 0 14px; }
  .admin-guide .MuiAccordionSummary-content { margin: 12px 0; }
  .admin-guide .MuiAccordionSummary-content > div { display: flex; flex-direction: column; gap: 3px; }
  .admin-guide .MuiAccordionSummary-content strong { color: var(--cms-text-primary); font-size: 14px; }
  .admin-guide .MuiAccordionSummary-content span { color: var(--cms-text-secondary); font-size: 11px; line-height: 1.4; }
  .admin-guide .MuiAccordionDetails-root {
    padding: 0 14px 14px;
    border-top: 1px solid var(--cms-border);
  }
  .guide-paradigm {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 12px 0;
  }
  .guide-paradigm span {
    padding: 4px 8px;
    border-radius: 999px;
    color: var(--cms-link-color);
    background: var(--cms-selected-bg);
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .guide-paradigm strong { color: var(--cms-text-primary); font-size: 13px; }
  .guide-grid { display: grid; gap: 12px; margin: 0; }
  .guide-grid > div {
    padding: 12px;
    border-radius: 12px;
    background: var(--cms-surface-secondary);
    box-shadow: inset 0 0 0 1px var(--cms-border);
  }
  .guide-grid dt { margin-bottom: 4px; color: var(--cms-text-primary); font-size: 12px; font-weight: 800; }
  .guide-grid dd { margin: 0; color: var(--cms-text-secondary); font-size: 12px; line-height: 1.55; }
  .toggles { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
  .toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 12px;
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
  }
  .toggle strong, .toggle span { display: block; }
  .toggle strong { color: var(--cms-text-primary); font-size: 13px; }
  .toggle span { margin-top: 2px; color: var(--cms-text-secondary); font-size: 11px; line-height: 1.35; }
  .page-empty { padding: 28px; color: var(--cms-text-secondary); text-align: center; }

  @media (max-width: 720px) {
    padding: 14px;
    .games-grid { grid-template-columns: 1fr; }
    .thumbnail-row, .toggles { grid-template-columns: 1fr; }
  }
`

export { NeuroFitnessGamesWrapper }
